var map = {
	"./PromoPegante.jpg": 470,
	"./PromoSilicona.jpg": 6222,
	"./promoSuperBonder.jpg": 3909,
	"./promoSuperBonderOri.jpg": 6759,
	"./promoTronex.jpg": 3603,
	"./promoTronexOri.jpg": 5237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6944;